export const API_URL = process.env.REACT_APP_API_URL || process.env.NEXT_PUBLIC_API_URL || process.env.API_URL || 'https://api.picsart.com';
export const UPLOAD_API_URL = process.env.REACT_APP_UPLOAD_URL || 'https://upload-stage.picsartstage2.com';
export const BASE_URL = process.env.PUBLIC_URL || '';
export const REFRESH_TOKEN_URL = `${API_URL}/oauth2/refresh`;
export const UNAUTHORIZED_STATUS_CODE = 401;
